function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(name) {
	var value = "; " + document.cookie;
	var parts = value.split("; " + name + "=");
	if (parts.length == 2) return parts.pop().split(";").shift();
}

jQuery(function () {
	if (getCookie("hideFooterlinker") != 1) jQuery("#footerlinker").animate({
		bottom: "0"
	});
	jQuery("#footerlink-closer").click(function () {
		setCookie("hideFooterlinker", 1, 7);
		jQuery("#footerlinker").animate({
			bottom: "-250"
		}, 500);
	})
})

var formdisabled = false;
jQuery( document ).ready(function() {
	
	jQuery("#submitmkform").click(function(){
		jQuery("#mkpopup").find('[type="submit"]').trigger('click');
	});


	jQuery("#showmkpopup").click(function(){
		jQuery("#mkformoverlay").css("display","block").css("opacity",1).css("z-index",10000);
		jQuery("#mkpopup").css("opacity",1).css("display","block");
		
	});

	jQuery("#mkformoverlay").click(function(){
		jQuery("#mkformoverlay").css("display","none").css("opacity",0).css("z-index",9998);
		jQuery("#mkpopup").css("display","none").css("opacity",0);
	}); 	

	jQuery("#mkpopup form").submit(function(e){
		if(formdisabled){
			e.preventDefault();
			return false;
		}
		if (document.getElementById("mkform").checkValidity()) {
			formdisabled = true;
			e.preventDefault();
        	jQuery.ajax({
	            url: 'https://mkuniverset.dk/wp-content/plugins/makeable-content-sync/mkformsubmit.php',
	            method: 'POST',
	            data: jQuery('#mkform').serialize(),
	            success: function (response) {
	                if(response == "200"){
	                	jQuery("#submitmkform").text("Tak for din tilmelding!");
	                	jQuery("#mkform").addClass("success");
	                }
	                else{
	                	formdisabled = false;
	                	alert("Hov... Tjek at din email er korrekt indtastet - eller måske er du allerede tilmeldt?");
	                }
	            }
        	})
    	}
	});
})